/* AI Agent làm theo chỉ thị của anh Hoá — 2026-10-15 16:10 VN — WEB-20261015-suzitee-home-menu
   Đã làm: điều khiển menu hamburger mobile toàn màn hình (#sz-mm).
   - Chỉ chạy khi (max-width: 798px) VÀ CSS sz-mm đã nạp (--sz-mm-ready); nếu không → để menu cũ của Turbo chạy như cũ.
   - Chặn click trên summary[data-mobile-menu-trigger] (capture) → mở overlay; trang con trượt sang, "‹ Back" quay lại.
   - Không MutationObserver, không đo layout trong scroll/resize; chỉ đổi class khi trạng thái đổi. Bọc try/catch. */
(function () {
  'use strict';
  try {
    var root = document.getElementById('sz-mm');
    if (!root || root.__szMm) return;
    root.__szMm = true;
    var mq = window.matchMedia('(max-width: 798px)');
    var html = document.documentElement;
    var rootPanel = root.querySelector('[data-sz-mm-panel="root"]');
    var activeSub = null;
    var lastTrigger = null;
    var closeTimer = null;

    function cssReady() {
      try { return getComputedStyle(html).getPropertyValue('--sz-mm-ready').trim() === '1'; } catch (e) { return false; }
    }
    function isOpen() { return root.classList.contains('is-open'); }

    function showRoot(instant) {
      if (!activeSub) return;
      var sub = activeSub;
      activeSub = null;
      sub.classList.remove('is-active');
      if (rootPanel) rootPanel.classList.remove('is-behind');
      if (instant) { sub.hidden = true; return; }
      setTimeout(function () { if (activeSub !== sub) sub.hidden = true; }, 300);
    }

    function showSub(id) {
      var sub = root.querySelector('[data-sz-mm-panel="' + id + '"]');
      if (!sub || sub === activeSub) return;
      if (activeSub) showRoot(true);
      sub.hidden = false;
      sub.scrollTop = 0;
      activeSub = sub;
      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          if (activeSub !== sub) return;
          sub.classList.add('is-active');
          if (rootPanel) rootPanel.classList.add('is-behind');
          var back = sub.querySelector('[data-sz-mm-back]');
          if (back) try { back.focus({ preventScroll: true }); } catch (e) {}
        });
      });
    }

    function open(trigger) {
      if (isOpen()) return;
      clearTimeout(closeTimer);
      lastTrigger = trigger || null;
      root.hidden = false;
      root.setAttribute('aria-hidden', 'false');
      html.classList.add('sz-mm-open');
      if (trigger) trigger.setAttribute('aria-expanded', 'true');
      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          root.classList.add('is-open');
          var c = root.querySelector('[data-sz-mm-close]');
          if (c) try { c.focus({ preventScroll: true }); } catch (e) {}
        });
      });
    }

    function close() {
      if (!isOpen() && root.hidden) return;
      root.classList.remove('is-open');
      root.setAttribute('aria-hidden', 'true');
      html.classList.remove('sz-mm-open');
      if (lastTrigger) {
        lastTrigger.setAttribute('aria-expanded', 'false');
        try { lastTrigger.focus({ preventScroll: true }); } catch (e) {}
      }
      clearTimeout(closeTimer);
      closeTimer = setTimeout(function () {
        if (isOpen()) return;
        root.hidden = true;
        showRoot(true);
      }, 220);
    }

    // Hamburger của Turbo: chặn ở pha capture để <details> cũ không mở chồng.
    document.addEventListener('click', function (e) {
      var t = e.target && e.target.closest ? e.target.closest('summary[data-mobile-menu-trigger]') : null;
      if (!t || !mq.matches || !cssReady()) return;
      e.preventDefault();
      e.stopPropagation();
      var d = t.parentNode;
      if (d && d.open) d.open = false;
      open(t);
    }, true);

    root.addEventListener('click', function (e) {
      // Bấm vào dải overlay (nền tối ngoài sheet) → đóng menu, giống Almagems
      if (e.target === root) { e.preventDefault(); if (activeSub) showRoot(true); close(); return; }
      var el = e.target && e.target.closest ? e.target.closest('[data-sz-mm-target],[data-sz-mm-back],[data-sz-mm-close]') : null;
      if (!el) return;
      e.preventDefault();
      if (el.hasAttribute('data-sz-mm-close')) close();
      else if (el.hasAttribute('data-sz-mm-back')) showRoot(false);
      else showSub(el.getAttribute('data-sz-mm-target'));
    });

    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape' || !isOpen()) return;
      if (activeSub) showRoot(false); else close();
    });

    // Xoay/đổi kích thước sang desktop khi đang mở → đóng.
    var onMq = function (ev) { if (!ev.matches && isOpen()) close(); };
    if (mq.addEventListener) mq.addEventListener('change', onMq); else if (mq.addListener) mq.addListener(onMq);

    // Quay lại trang bằng bfcache khi menu còn mở → đóng sạch.
    window.addEventListener('pageshow', function (e) { if (e.persisted && isOpen()) { close(); } });
  } catch (err) {
    if (window.console) console.warn('[sz-mm]', err);
  }
})();
